import { Model } from '@vuex-orm/core'
import Room from '@models/building/Room'
import Roomtype from '@models/helpers/Roomtype'
import Roomltm from '@models/helpers/Roomltm'
import pageValidation from '@services/validations/pageValidation'

export default class Systemselection extends Model{
  static entity = 'systemselections'
  static fields () {
    return {
      id: this.uid(),
      unitId: this.attr(null),

      pipeSystem: this.number(1),
      pipeProfile: this.number(1),
      distributorSystem: this.number(1),
      deviceLevel: this.number(null).nullable(),
      sectionSelection: this.number(null).nullable(),
      ewtSystem: this.number(0),
      wrgSingleRoomDevice: this.number(null).nullable(),
    }
  }
} 